import type { INxAppLayout } from '../types';

interface IIsDirectQueryEnabled {
  appLayout: INxAppLayout;
}

export default function isDirectQueryEnabled({ appLayout }: IIsDirectQueryEnabled) {
  return !!appLayout?.qIsDirectQueryMode;
}
